import React from 'react';
import { Row, Col, Label, Input, FormGroup } from 'reactstrap';
import CustomSelect from './CustomSelect';
import { FormattedMessage } from 'react-intl';
import { useEffect } from 'react';
import { getAPI } from '../API';
import { CheckAuthorization } from '../Authorization';


// The resident room list ('charge to room') is owned by the parent, which knows the emission
// hotel and keeps one list per hotel while the modal is open; it is only rendered here.
const OperatorDataSection = ({
    operatorData,
    handleSelect,
    handlePaymentCodeSelect,
    handleHostUserPass,
    hideTitle = false,
    showPaymentDestination = false,
    chargeToRoom = false,
    roomFolio = null,
    rooms = [],
    blockRooms = false,
    onPaymentDestinationChange,
    onRoomSelect
}) => {
    const [paymentMethods, setPaymentMethods] = React.useState([]);
    const [pmsUsers, setPmsUsers] = React.useState([]);
    const [blockPaymentMethods, setBlockPaymentMethods] = React.useState(false);
    const [blockPmsUsers, setBlockPmsUsers] = React.useState(false);

    useEffect(() => {
        getPmsPaymentMethods();
        getPmsUsers();
    }, []);

    const getPmsPaymentMethods = () => {
         setBlockPaymentMethods(true);

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                setBlockPaymentMethods(false);

                return;
            }
            if (data) {
                let arr = [];
                data.response && data.response.map((el) => { return arr.push({ value: el.code, label: el.description }) })

                setPaymentMethods(arr);
                setBlockPaymentMethods(false);
            }
            else 
                setBlockPmsUsers(false);
        }, `/api/Voucher/v1/Config/paymentMethods`);
    }

    const getPmsUsers = () => {
        setBlockPmsUsers(true);

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                setBlockPmsUsers(false);

                return;
            }
            if (data) {
                let users = [];

                data.response && data.response.map((el) => {
                    var obj = { value: el.userCode, label: el.firstName + ' ' + el.lastName };

                    var cashBoxes = [];
                    el.cashBoxes && el.cashBoxes.map(el => {
                        cashBoxes.push({ value: el.cashBoxCode, label: el.cashBoxDescription });
                    });

                    obj.cashBoxes = cashBoxes;

                    users.push(obj)
                })

                setPmsUsers(users);
                setBlockPmsUsers(false);
            }
            else 
                setBlockPmsUsers(false);
        }, `/api/Voucher/v1/Config/pmsUsers`);
    }

    const hostUserCodeField = (
        <>
            <Col className="col-2">
                <Label>
                    <FormattedMessage id="AddVoucher.HostUserCode" />
                </Label>
            </Col>
            <Col className="col-4">
                <CustomSelect
                    options={pmsUsers}
                    value={pmsUsers.find(el => el.value === operatorData.hostUserCode) || ''}
                    name="hostUserCode"
                    onChange={handleSelect}
                    placeholder={<FormattedMessage id="AddVoucher.HostUserCode" />}
                    required={operatorData.hostUserCashboxCode || operatorData.HostPaymentCodes[0].hostPaymentCode || operatorData.hostUserPassword || roomFolio}
                    isLoading={blockPmsUsers}
                />
            </Col>
        </>
    );

    const hostUserCashboxField = (
        <>
            <Col className="col-2">
                <Label>
                    <FormattedMessage id="AddVoucher.HostUserCashboxCode" />
                </Label>
            </Col>
            <Col className="col-4">
                <CustomSelect
                    options={operatorData.hostUserCode ? pmsUsers.find(el => el.value === operatorData.hostUserCode).cashBoxes : ''}
                    name="hostUserCashboxCode"
                    value={operatorData.hostUserCode && operatorData.hostUserCashboxCode ? pmsUsers.find(el => el.value === operatorData.hostUserCode).cashBoxes.find(el => el.value === operatorData.hostUserCashboxCode) : null}
                    onChange={handleSelect}
                    placeholder={<FormattedMessage id="AddVoucher.HostUserCashboxCode" />}
                    isDisabled={operatorData.hostUserCode ? false : true}
                    required={operatorData.hostUserCode || operatorData.HostPaymentCodes[0].hostPaymentCode || operatorData.hostUserPassword}
                />
            </Col>
        </>
    );

    const hostPaymentCodeField = (
        <>
            <Col className="col-2">
                <Label>
                    <FormattedMessage id="AddVoucher.HostPaymentCode" />
                </Label>
            </Col>
            <Col className="col-4">
                <CustomSelect
                    options={paymentMethods}
                    value={paymentMethods.find(el => el.value === operatorData.HostPaymentCodes[0].hostPaymentCode) || ''}
                    name="hostPaymentCode"
                    onChange={handlePaymentCodeSelect}
                    placeholder={<FormattedMessage id="AddVoucher.HostPaymentCode" />}
                    required={operatorData.hostUserCashboxCode || operatorData.hostUserCode || operatorData.hostUserPassword}
                    isLoading={blockPaymentMethods}
                />
            </Col>
        </>
    );

    const hostUserPasswordField = (
        <>
            <Col className="col-2">
                <Label>
                    <FormattedMessage id="AddVoucher.HostUserPassword" />
                </Label>
            </Col>
            <Col className="col-4">
                <FormattedMessage id="AddVoucher.HostUserPassword">
                    {placeholder => (
                        <Input
                            type="password"
                            required={operatorData.hostUserCode || operatorData.HostPaymentCodes[0].hostPaymentCode || operatorData.hostPaymentCode || roomFolio}
                            value={operatorData.hostUserPassword !== null ? operatorData.hostUserPassword : ''}
                            name="hostUserPassword"
                            onChange={handleHostUserPass}
                            placeholder={placeholder}
                        />
                    )}
                </FormattedMessage>
            </Col>
        </>
    );

    return (
        <div>
            {hideTitle ? null :
                <>
                    <Row className="mt-4">
                        <Col>
                            <h5>
                                <FormattedMessage id="AddVoucher.OperatorData" />
                            </h5>
                        </Col>
                    </Row>
                    <hr className="mb-3 mt-0" />
                </>
            }
            {showPaymentDestination ?
                <>
                    {CheckAuthorization("admin:view") ?
                        <Row className="mb-2 align-items-center">
                            <Col className="col-2 pb-2">
                                <Label>
                                    <FormattedMessage id="AddVoucher.PaymentDestination" />
                                </Label>
                            </Col>
                            <Col className="col-4 pb-2">
                                <FormGroup check inline className="mb-0">
                                    <Label check>
                                        <Input
                                            type="radio"
                                            name="paymentDestination"
                                            checked={!chargeToRoom}
                                            onChange={() => onPaymentDestinationChange(false)}
                                        />
                                        <FormattedMessage id="AddVoucher.Pay" />
                                    </Label>
                                </FormGroup>
                                <FormGroup check inline className="mb-0">
                                    <Label check>
                                        <Input
                                            type="radio"
                                            name="paymentDestination"
                                            checked={chargeToRoom}
                                            onChange={() => onPaymentDestinationChange(true)}
                                        />
                                        <FormattedMessage id="AddVoucher.ChargeToRoom" />
                                    </Label>
                                </FormGroup>
                            </Col>
                            {chargeToRoom ?
                                <>
                                    <Col className="col-2">
                                        <Label>
                                            <FormattedMessage id="AddVoucher.Room" />
                                        </Label>
                                    </Col>
                                    <Col className="col-4">
                                        <CustomSelect
                                            options={rooms}
                                            value={rooms.find(r => r.value === roomFolio) || ''}
                                            onChange={onRoomSelect}
                                            placeholder={<FormattedMessage id="AddVoucher.SelectRoom" />}
                                            isLoading={blockRooms}
                                            required
                                        />
                                    </Col>
                                </>
                            : ''}
                        </Row>
                    : ''}
                    <Row className="mb-2">
                        {hostUserCodeField}
                        {hostUserPasswordField}
                    </Row>
                    {chargeToRoom ? null :
                        <Row className="mb-2">
                            {hostPaymentCodeField}
                            {hostUserCashboxField}
                        </Row>
                    }
                </>
                :
                <>
                    <Row className="mb-2">
                        {hostUserCodeField}
                        {hostUserCashboxField}
                    </Row>
                    <Row className="mb-2">
                        {hostPaymentCodeField}
                        {hostUserPasswordField}
                    </Row>
                </>
            }
        </div>
    );
};

export default OperatorDataSection;
